module.exports = __webpack_public_path__ + "static/media/hipcamp-logo.303c3307.svg";